import { apiClient } from './client';
import type { ApiEnvelope } from './types';

export interface KilometroItem {
  id: number;
  fecha: string | null;
  vehiculo_placa: string;
  vehiculo_marca: string;
  vehiculo_modelo: string;
  conductor_nombre: string;
  conductor_id: number | null;
  vehiculo_id: number | null;
  kilometros_recorridos: number;
  tipo_entrega: string;
}

export interface KilometrosReporte {
  items: KilometroItem[];
  count: number;
  page: number;
  page_size: number;
  total_pages: number;
  has_next: boolean;
  has_previous: boolean;
  total_kilometros: number;
}

export interface KilometrosParams {
  fecha_desde?: string;
  fecha_hasta?: string;
  page?: number;
  page_size?: number;
}

export function getReporteKilometros(params?: KilometrosParams): Promise<KilometrosReporte> {
  const queryParams: Record<string, string> = {};
  if (params?.fecha_desde) queryParams.fecha_desde = params.fecha_desde;
  if (params?.fecha_hasta) queryParams.fecha_hasta = params.fecha_hasta;
  if (params?.page) queryParams.page = String(params.page);
  if (params?.page_size) queryParams.page_size = String(params.page_size);

  return apiClient
    .get<ApiEnvelope<KilometrosReporte>>('/api/v1/transporte/reportes/kilometros/', queryParams)
    .then(response => response.data);
}
